<template>
  <div>
    <!-- リスキリング補助制度：通常コース -->
    <div
      v-if="showEntryReskilling"
      class="flex flex-col items-baseline border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8"
    >
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_reskilling"
      >
        リスキリング補助制度
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="basis-full md:basis-8/12">
        <div
          id="entry_reskilling"
          class="mb-2 flex gap-x-4"
          @change="changeEntryReskillingSelected(entryReskillingSelected)"
        >
          <div
            v-for="(option, index) in entryReskillingOptions"
            :key="index"
            class="form-control"
          >
            <label class="cursor-pointer">
              <input
                v-model="entryReskillingSelected"
                type="radio"
                :value="option.value"
                :disabled="option.disabled"
                name="entry-reskilling"
                required
                class="radio"
              >
              <span class="ml-2">{{ option.text }}</span>
            </label>
          </div>
        </div>
        <span
          v-if="errors.reskilling && errors.reskilling.length !== 0"
          class="te-invalid-feedback inline-block"
        >
          {{ errors.reskilling.join(", ") }}
        </span>
        <!-- 利用するを選択した場合のアラート -->
        <div v-if="entryReskillingSelected === '0'">
          <p class="co-display-13 mb-0  mt-2">
            ※ 利用する場合は、下記の点に承諾しているものとみなします。
          </p>
          <ul class="co-display-13 mb-0 list-disc  pl-6">
            <li>
              <a
                href="/benefits/reskilling#eligible"
                target="_blank"
              >
                対象条件
              </a>
              や
              <a
                href="/benefits/reskilling#condition"
                target="_blank"
              >
                注意事項
              </a>
              を理解して申し込みを行う
            </li>
          </ul>
        </div>
        <!-- 4週間プラン選択時のアラート -->
        <div v-if="!reskillingEnabled">
          <p class="co-display-13 mb-0 mt-2">
            <FontAwesomeIcon
              :icon="faBullhorn"
              class="fa-fw mr-2 inline text-[1rem] text-co-danger-500"
            />
            4週間プランはリスキリング補助制度の対象外です
          </p>
        </div>

        <!-- Liteプラン選択時のアラート -->
        <div v-if="isLitePlan">
          <p class="co-display-13 mb-0 mt-2">
            <FontAwesomeIcon
              :icon="faBullhorn"
              class="fa-fw mr-2 inline text-[1rem] text-co-danger-500"
            />
            Liteプランはリスキリング補助制度の対象外です
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TeCommonBadgeRequired from '~/components/Te/TeCommon/Badge/TeCommonBadgeRequired/TeCommonBadgeRequired.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBullhorn } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface TextValue {
  value: string
  text: string
}

interface Data {
  entryReskillingSelected: string
}

interface Methods {
  changeEntryReskillingSelected: (selected: string) => void
}

interface Computed {
  entryReskillingOptions: TextValue[]
}

interface Props {
  courseNamePath: string
  showEntryReskilling: boolean
  showIsProBenefitSystem: boolean
  isLitePlan: boolean
  reskillingEnabled: boolean
  errors: any
}

const options = {
  async setup() {
    return {
      faBullhorn,
    }
  },
  props: {
    courseNamePath: {
      type: String,
      default: '',
    },
    showEntryReskilling: {
      type: Boolean,
      default: false,
    },
    showIsProBenefitSystem: {
      type: Boolean,
      default: false,
    },
    isLitePlan: {
      type: Boolean,
      default: false,
    },
    reskillingEnabled: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // リスキリング補助制度：通常コース
      entryReskillingSelected: '', // ラジオボタンの選択初期状態
    }
  },
  methods: {
    changeEntryReskillingSelected(selected: string) {
      this.$emit('changeEntryReskillingSelected', selected)
    },
  },
  computed: {
    entryReskillingOptions() {
      return [
        {
          value: '0',
          text: '利用する',
          disabled: !this.reskillingEnabled || this.isLitePlan,
        },
        { value: '1', text: '利用しない' },
      ]
    },
  },
  components: {
    TeCommonBadgeRequired,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-invalid-feedback {
  width: 100%;
  margin-top: .25rem;
  font-size: .875em;
  color: #dc3545;
}
</style>
